export default __webpack_public_path__ + "static/media/Group 88.b86c4e56.png";